import * as React from "react"

export function FormField({ label, error, hint, children }: { label: string; error?: string; hint?: string; children: React.ReactNode }) {
  const descriptionId = React.useId()
  const description = error || hint
  const control = React.isValidElement<Record<string, unknown>>(children)
    ? React.cloneElement(children, {
        "aria-describedby": description ? descriptionId : undefined,
        "aria-invalid": error ? true : undefined,
      })
    : children

  return (
    <label className="block text-sm font-medium text-ink-display">
      <span>{label}</span>
      {control}
      {description && <span id={descriptionId} role={error ? "alert" : undefined} className={error ? "mt-1 block text-xs font-medium text-danger-display" : "mt-1 block text-xs text-ink-muted"}>{description}</span>}
    </label>
  )
}
